import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { Text } from 'shared/ui/common/Text'
import { NFCSFormStep } from 'modules/nfcs/types'

import s from './NFCSFormAddDescription.module.scss'

export const NFCSFormAddDescription = () => {
  const { walletAddress } = useWeb3()
  const { currentFormStep, signedAddresses } = useNFCSState()

  if (currentFormStep === NFCSFormStep.Start) {
    return (
      <Text color="secondary" size={14} isCentered className={s.note}>
        Switch to the address that you want to add to the bundle.
      </Text>
    )
  }

  if (currentFormStep === NFCSFormStep.Finish) {
    return (
      <>
        <Text color="secondary" size={14} isCentered className={s.lastStep}>
          Sign your primary address by clicking a button below
        </Text>
        {walletAddress && walletAddress !== signedAddresses[0] && (
          <Text color="inherit" size={14} isCentered className={s.warningNote}>
            You must re-connect to the primary address before initiating NFCS
            mint
          </Text>
        )}
      </>
    )
  }

  return null
}
